/**
 * Australian currency formatting.
 */

const AUD_FORMATTER = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  maximumFractionDigits: 0,
})

const AUD_FORMATTER_DECIMAL = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/**
 * Format a number as Australian currency: "$123,456".
 */
export function formatCurrency(
  amount: number | null | undefined,
  options?: { decimals?: boolean }
): string {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return "—"
  return options?.decimals ? AUD_FORMATTER_DECIMAL.format(amount) : AUD_FORMATTER.format(amount)
}

/**
 * Format a number as compact Australian currency: "$1.2M", "$45K".
 */
export function formatCompactCurrency(amount: number | null | undefined): string {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return "—"
  if (Math.abs(amount) >= 1_000_000) return `$${(amount / 1_000_000).toFixed(1)}M`
  if (Math.abs(amount) >= 1_000) return `$${(amount / 1_000).toFixed(0)}K`
  return `$${amount.toFixed(0)}`
}

/**
 * Parse a currency string like "$1,234.56" to a number.
 */
export function parseCurrency(value: string): number | null {
  const cleaned = value.replace(/[^0-9.-]/g, "")
  if (!cleaned) return null
  const parsed = parseFloat(cleaned)
  return Number.isNaN(parsed) ? null : parsed
}
